<div *ngIf='!tabbed' class="ingredient-choices">
  <button class="btn btn-link btn-undecorated btn-block btn-choice text-left fw-300 font-secondary ingredient-choice" (click)='toggleExpanded()' [attr.aria-expanded]="expanded">
    <div class="choice-wrapper align-items-start">
      <fa-icon class="expander" [fixedWidth]="true" [icon]="faAngleRight" [ngClass]="{'fa-rotate-90': expanded}"></fa-icon>
      <div class="choice-name-and-warning" [ngClass]="{'w-100': isHalfAndHalf && !choice.hasHalves}"> 
        <div class="choice-name-wrapper">
          <span>{{choice.name}}</span>
          <span class="whole-application-label" *ngIf="isHalfAndHalf && isMobile && !choice.hasHalves">
            {{'component.item_editor.choice.will_be_applied_to_both_halves' | translate}}
          </span>
        </div>
        <span class="badge bg-warning text-uppercase choice-attention-label primary-text-color" *ngIf='orderedChoice?.warnings?.length && !expanded' data-flash>
          {{'component.item_editor.choice.attention' | translate}}
        </span>
        <span class="flex-grow-1 justify-content-end whole-application-label" *ngIf="isHalfAndHalf && !isMobile && !choice.hasHalves">
          {{'component.item_editor.choice.will_be_applied_to_both_halves' | translate}}
        </span>
      </div>
    </div>
  </button>
</div>

<div class='choice-details'
     [ngClass]="{'collapsed': collapsedChoice}"
     [@expanded]="this.tabbed || this.expanded"
     (@expanded.start)="expandedAnimationStarted($event)"
     (@expanded.done)="expandedAnimationEnd($event)" 
     id="{{'choice-' + (choice.name | slugify)}}">
  <ng-container *ngIf="this.tabbed || this.expanded">
    <p class='fw-500 calorie-disclaimer' *ngIf='caloriesDisclaimer && !tabbed'>{{caloriesDisclaimer}}</p>
    <ng-container *ngIf="isDependingIngredientOrdered && showValidationMessages">
      <div role="alert" aria-atomic="true" class="alert alert-danger choice-error primary-bg-color" *ngFor='let warning of orderedChoice?.warnings'>
        {{warning}}
      </div>
    </ng-container>
    <div *ngIf="choice?.recommendedIngredients && (theme?.ingredientChoicesType !== 'Steps' || (theme?.ingredientChoicesType === 'Steps' && hasChoiceGroups)) && (orderedChoice?.ingredients.length < choice?.recommendedIngredients)" class="primary-bg-color alert">
      {{'component.item_editor.item_choices.recommended_ingredients' | translate: {recommendedIngredients: choice?.recommendedIngredients} }}
    </div>
    <div
      role="alert"
      aria-atomic="true"
      *ngIf="choice.maxIngredients === 1 && !choice.needsSingleIngredientSelection"
      class="alert choice-error"
      [ngClass]="isMobile ? 'no-padding' : 'alert-info primary-bg-color'">
      {{'component.item_editor.choice.max_one_ingredient' | translate}}
    </div>

    <div role="alert" aria-atomic="true" class="alert" *ngIf="!isDependingIngredientOrdered"
      [ngClass]="isMobile ? 'no-padding margin-bottom-10' : 'alert-warning'" data-flash>
      {{'component.item_editor.choice.need_to_have' | translate: {dependsOn: choice.dependsOn, name: choice.name} }}
    </div>

    <div *ngIf="!showColumnLayout && !showAccordionLayout && !ignoreIngredientGroups && choice.groups?.length" class='btn-group ingredient-groups d-block'>
      <button *ngFor="let group of choice.groups"
         class="btn ingredient-group-btn primary-bg-color shadowed fw-300 font-secondary"
         [ngClass]="{'selection-bg-color selection-inverse-text-color': selectedIngredientGroup?.choiceGroup === group.choiceGroup}"
         [ngModel]="selectedIngredientGroup?.choiceGroup"
         (click)='selectGroup(group, $event)'
         [value]="group.choiceGroup"
         [attr.aria-pressed]="selectedIngredientGroup?.choiceGroup === group.choiceGroup"
         ngDefaultControl>
        <span>{{group.choiceGroup}}</span>
    </button>
    </div>

    <div class="mt-1 mb-1" *ngIf="tagList?.length">
      <fts-filtering-tags 
        [tags]="tagList" 
        [theme]="theme"
        [selectedTags]="selectedTags"
        [isIngredientTagList]="true"
        (tagClicked)="onTagClicked($event)"
        (clearTags)="clearSelectedTags()"></fts-filtering-tags>
    </div>

    <fieldset>
      <legend class="sr-only">{{'component.item_editor.choice.ing_choices' | translate}}</legend>
      
      <div *ngIf="showAccordionLayout" class="accordion-layout">
        <ng-container *ngFor="let item of groupedIngredients">
          <button class="btn btn-link btn-undecorated text-left fw-600 text-uppercase font-secondary px-0 accordion-group-btn"
                  (click)="toggleGroup(item.group.choiceGroup)"
                  [attr.aria-label]="item.group.choiceGroup" 
                  [attr.aria-expanded]="expandedGroups[item.group.choiceGroup]">
            <span>{{item.group.choiceGroup}}</span>
            <fa-icon aria-hidden="true" [icon]="expandedGroups[item.group.choiceGroup] ? faChevronUp : faChevronDown"></fa-icon>
          </button>
          
          <div *ngIf="expandedGroups[item.group.choiceGroup]"
               [ngClass]="{'panel-expanded' : expandedGroups[item.group.choiceGroup]}"
               [@expanded]="expandedGroups[item.group.choiceGroup]"
               (@expanded.done)="expandedAnimationEnd($event)">
               
            <div class="form-group instructions-panel no-margin padded-bottom-15">
              <ng-container *ngFor="let ingredient of item.ingredients; trackBy: trackByIngredientFn; let i = index;">
                <fts-ingredient
                  *ngIf="!!(ingredient | sizePrice : itemSize) || storeConfig?.showSizeSpecificIngredients"
                  class="flat-ingredient"
                  [needsMaxIngredientsWarningsCheck]="needsMaxIngredientsWarningsCheck"
                  [ingredient]='ingredient'
                  [itemSize]='itemSize'
                  [choice]='choice'
                  [isInModal]="isInModal"
                  [inItemEditorModal]="inItemEditorModal"
                  [disabled]='!isDependingIngredientOrdered'
                  [ingredientIndex]="i"
                  [singleSelectionChoiceSelectedIngredient]='orderedChoice?.firstIngredient'
                  [orderedChoice]="orderedChoice"
                  [hasGraphicalBuilder]="hasGraphicalBuilder"
                  [storeConfig]="storeConfig"
                  [hasTags]="!!ingredient.tags.length"
                  [hasTagList]="!!tagList.length"
                  (ingredientHalfChange)='selectHalf($event)'
                  (ingredientQualifierChange)='onToggleQualifier($event)'
                  (ingredientSelectedChange)='onToggleIngredient($event)'
                  (tagClicked)="onTagClicked($event)"
                ></fts-ingredient>
              </ng-container>
            </div>
            
          </div>
        </ng-container>
      </div>

      <!-- EXISTING: Column Layout -->
      <div *ngIf="showColumnLayout" class="grouped-columns-wrapper">
        <div *ngFor="let item of groupedIngredients" class="group-column">
          <p class="group-header">{{ item.group.choiceGroup }}</p>
          <div class="column-content">
            <ng-container *ngFor="let ingredient of item.ingredients; trackBy: trackByIngredientFn; let i = index;">
              <fts-ingredient
                *ngIf="!!(ingredient | sizePrice : itemSize) || storeConfig?.showSizeSpecificIngredients"
                class="flat-ingredient"
                [needsMaxIngredientsWarningsCheck]="needsMaxIngredientsWarningsCheck"
                [ingredient]='ingredient'
                [itemSize]='itemSize'
                [choice]='choice'
                [isInModal]="isInModal"
                [inItemEditorModal]="inItemEditorModal"
                [disabled]='!isDependingIngredientOrdered'
                [ingredientIndex]="i"
                [singleSelectionChoiceSelectedIngredient]='orderedChoice?.firstIngredient'
                [orderedChoice]="orderedChoice"
                [hasGraphicalBuilder]="hasGraphicalBuilder"
                [storeConfig]="storeConfig"
                [hasTags]="!!ingredient.tags.length"
                [hasTagList]="!!tagList.length"
                (ingredientHalfChange)='selectHalf($event)'
                (ingredientQualifierChange)='onToggleQualifier($event)'
                (ingredientSelectedChange)='onToggleIngredient($event)'
                (tagClicked)="onTagClicked($event)"
              ></fts-ingredient>
            </ng-container>
          </div>
        </div>
      </div>

      <div *ngIf="!showColumnLayout && !showAccordionLayout" class="ingredients-wrapper ingredients" [ngClass]="{'editor-margins' : choice?.showIngredientImages && !(halfsOrderingService.isHalfAndHalf$ | async)}">
        <ng-container *ngFor='let ingredient of filteredIngredient | ingredientGroupFilter:selectedIngredientGroup?.ingredients;
          trackBy: trackByIngredientFn; let ingredientIndex = index;'>

          <fts-ingredient
            *ngIf="!!(ingredient | sizePrice : itemSize) || storeConfig?.showSizeSpecificIngredients"
            [ngClass]="{
              'two-columned': (!choice.showIngredientImages || (halfsOrderingService.isHalfAndHalf$ | async)) && 
                (!showThreeColumns || inItemEditorModal || (isInModal && filteredIngredient.length === 1)) && 
                (filteredIngredient.length > 1 || (filteredIngredient.length === 1 && (inItemEditorModal || isInModal))),
              'three-columned': (!choice.showIngredientImages || (halfsOrderingService.isHalfAndHalf$ | async)) && showThreeColumns && !inItemEditorModal,
              'flat-ingredient' :  (!choice.showIngredientImages || (halfsOrderingService.isHalfAndHalf$ | async))
            }"
            [needsMaxIngredientsWarningsCheck]="needsMaxIngredientsWarningsCheck"
            [ingredient]='ingredient'
            [itemSize]='itemSize'
            [choice]='choice'
            [isInModal]="isInModal"
            [inItemEditorModal]="inItemEditorModal"
            [disabled]='!isDependingIngredientOrdered'
            [ingredientIndex]="ingredientIndex"
            [singleSelectionChoiceSelectedIngredient]='orderedChoice?.firstIngredient'
            [orderedChoice]="orderedChoice"
            [hasGraphicalBuilder]="hasGraphicalBuilder"
            [storeConfig]="storeConfig"
            [hasTags]="!!ingredient.tags.length"
            [hasTagList]="!!tagList.length"
            (ingredientHalfChange)='selectHalf($event)'
            (ingredientQualifierChange)='onToggleQualifier($event)'
            (ingredientSelectedChange)='onToggleIngredient($event)'
            (tagClicked)="onTagClicked($event)"
          ></fts-ingredient>
        </ng-container>
      </div>
    </fieldset>
  </ng-container>

</div>
